function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.4648 17.2139V4.124C16.4638 3.22753 15.7388 2.50106 14.8441 2.5H6.03317C5.13843 2.50097 4.41334 3.22749 4.41237 4.124V17.2139H3.43335V18.5H17.4437V17.2139H16.4648ZM11.2651 15.5573V17.2139H9.61173V15.5573H11.2651ZM8.32811 17.2139V14.2712H12.5486V17.2139H15.181V4.12399C15.1808 3.9375 15.03 3.78633 14.8439 3.78607H6.03281C5.84669 3.78633 5.6959 3.9375 5.69572 4.12399V17.2139H8.32811Z",
  fill: "#5F6972"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 7.28824,
  y: 4.86264,
  width: 2.27979,
  height: 2.27979,
  fill: "#5F6972"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 11.3504,
  y: 4.86264,
  width: 2.2798,
  height: 2.27979,
  fill: "#5F6972"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 7.28824,
  y: 7.88855,
  width: 2.27979,
  height: 2.27979,
  fill: "#5F6972"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 11.3504,
  y: 7.88855,
  width: 2.2798,
  height: 2.27979,
  fill: "#5F6972"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 7.28824,
  y: 10.956,
  width: 2.27979,
  height: 2.2798,
  fill: "#5F6972"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 11.3504,
  y: 10.956,
  width: 2.2798,
  height: 2.2798,
  fill: "#5F6972"
});

const SvgMedium = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMedium, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Medium.fbdd332e.svg";
export { ForwardRef as ReactComponent };